import Toast from '@naturehouse/design-system/components/atoms/toast/Toast';

export default function createToast(content: string | HTMLElement): Toast {
    const toast: Toast = new Toast(content);
    document.body.appendChild(toast);

    return toast;
}
